import { Component, OnInit,OnChanges,SimpleChanges,Input } from '@angular/core';

@Component({
  selector: 'sb-chart-horizontal',
  templateUrl: './horizontal-chart.component.html',
  styleUrls: ['./horizontal-chart.component.css']
})
export class HorizontalChartComponent implements OnInit,OnChanges {
  @Input() chartInputId:any;
  @Input() dataChart: {data: any[]};
  chartId: string="1";
  lstData:any;
  constructor() { }
  ngOnInit(): void {
    this.chartId=this.chartInputId;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataChart.currentValue) {      
      this.renderHorizontalChart();
    }
  }
  renderHorizontalChart(){
    this.lstData=this.dataChart.data;
  }
}
